import { render, staticRenderFns } from "./DialogRemunerationsDetail.vue?vue&type=template&id=ad38d0ae&lang=pug&"
import script from "./DialogRemunerationsDetail.vue?vue&type=script&lang=js&"
export * from "./DialogRemunerationsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DialogRemunerationsDetail.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContainer,
  VDataTable,
  VDialog,
  VFlex,
  VIcon,
  VLayout,
  VSpacer,
  VSubheader,
  VToolbar,
  VToolbarTitle,
})
